"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrefetchNutrition = exports.useNutrition = void 0;

var _reactQuery = require("react-query");

var _api = require("../api");

var useNutrition = function useNutrition(nutritionKey) {
  return (0, _reactQuery.useQuery)(["Nutrition"
  /* Nutrition */
  , nutritionKey], function () {
    return (0, _api.fetchNutrition)(nutritionKey);
  }, {
    enabled: !!nutritionKey,
    refetchOnMount: false,
    staleTime: 120 * 1000
  });
};

exports.useNutrition = useNutrition;

var usePrefetchNutrition = function usePrefetchNutrition(nutritionKey) {
  var queryClient = (0, _reactQuery.useQueryClient)();
  return function () {
    return queryClient.prefetchQuery(["Nutrition"
    /* Nutrition */
    , nutritionKey], function () {
      return (0, _api.fetchNutrition)(nutritionKey);
    }, {
      staleTime: 10 * 1000
    });
  };
};

exports.usePrefetchNutrition = usePrefetchNutrition;